import { OuraRing4CeramicLogo } from '@jouzen/ecom-components/icons/OuraRing4CeramicLogo';
import { InverseHeader } from '@jouzen/ecom-components/layout';
import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { usePathname } from 'next/navigation';

import { EventType } from '@/analytics/types';
import FullScreenHero from '@/app/components/FullScreenHero';
import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';
import { OR4_JADE_POP_PATHNAME } from '@/app/consts/pathnames';

import OR4CeramicHeroBackground from './common/OR4CeramicHeroBackground';

const OR4CeramicHero = () => {
  const path = usePathname();

  return (
    <InverseHeader>
      <div
        className="relative overflow-x-clip bg-sandstone-200"
        data-cy="or4-ceramic-hero"
      >
        <FullScreenHero Background={OR4CeramicHeroBackground}>
          <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
            <div className="flex h-svh flex-col items-center pb-8 text-sandstone-500 md:pb-20">
              <Motion
                className="mt-auto md:mt-40"
                initial={{
                  opacity: 0,
                  translateY: 25,
                  filter: 'blur(5px)',
                }}
                animate={{ opacity: 1, translateY: 0, filter: 'blur(0)' }}
                transition={{ duration: 1.25, type: 'tween', delay: 0.5 }}
              >
                <span className="mb-3 flex flex-row items-center justify-center md:mb-5">
                  <OuraRing4CeramicLogo className="h-5 lg:h-6" />
                </span>
                <Typography
                  className="text-center text-6xl tracking-tighter text-balance md:text-7xl lg:text-[6.875rem]"
                  Element="h1"
                  font="serif"
                >
                  <RichText messageKey="jade_home_hero_title" />
                </Typography>
              </Motion>
              <Motion
                className="mt-4 md:mt-auto"
                animate={{ opacity: 1 }}
                initial={{ opacity: 0 }}
                transition={{ duration: 1.25, type: 'tween', delay: 0.75 }}
              >
                <Button
                  className="font-bold"
                  href={OR4_JADE_POP_PATHNAME}
                  onClick={() => {
                    void window.ouraAnalytics.track(EventType.CTAClicked, {
                      cta: 'explore',
                      action: 'go_to_pdp',
                      location: 'home hero',
                      path,
                    });
                  }}
                  variant="primary"
                >
                  <RichText messageKey="explore" />
                </Button>
              </Motion>
            </div>
          </GridItem>
        </FullScreenHero>
      </div>
    </InverseHeader>
  );
};

export default OR4CeramicHero;
